import { styled } from 'styled-components'
import { ReactComponent as TariffCoin } from 'images/icons/tariff-coin.svg'
import { XNoPaddingIcon } from 'icons'

export const Notice = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 10px 8px;
  background: rgba(129, 102, 35, 0.15);
  color: #4e3e13;
  font-size: 15px;
  font-weight: 500;
  line-height: 17px;
`

export const Message = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export const Coin = styled(TariffCoin)`
  display: block;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
`

// The notice's own side padding is 8px; the rest keeps the X off the edge and
// widens its hit area.
export const DismissButton = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0 12px 0 0;
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
`

export const DismissIcon = styled(XNoPaddingIcon)`
  width: 12px;
  height: 12px;
`
